import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/esm/Modal';
import { useAppDispatch, useAppSelector } from '../../useStore';
import { getalljobsbyID, reset } from '../../features/Job/jobSlice';
import moment from "moment"
import CopyToClipboardButton from './CopyToClipboardButton';
import swal from 'sweetalert';
import { hostbaseUrl } from '../../shared/baseUrl';
import QrCodeGenerator from '../QrCodeGenerator/QrCodeGenerator';

const ViewJobModal = ({ show, setShow, id }: any) => {
	const dispatch = useAppDispatch();
	const { dataID, isErrorID, isLoadingID, messageID } = useAppSelector((state: any) => state.job)

	const [link, setLink] = useState<any>(false)

	useEffect(() => {
		// @ts-ignore
		dispatch(getalljobsbyID(id));
	}, [dispatch, id]);

	const systemFields = [
		{ fields: "First Name", status: "Yes" },
		{ fields: "Last Name", status: "Yes" },
		{ fields: "Email", status: "Yes" },
		{ fields: "Resume", status: !dataID?.data?.resume ? "N/A" : dataID?.data?.resume === true ? "Yes" : "No" },
		{ fields: "LinkedIn Url", status: !dataID?.data?.resume ? "N/A" : dataID?.data?.resume === true ? "Yes" : "No" },
		{ fields: "Phone", status: !dataID?.data?.resume ? "N/A" : dataID?.data?.resume === true ? "Yes" : "No" },
		{ fields: "Curent Salary Status", status: !dataID?.data?.resume ? "N/A" : dataID?.data?.resume === true ? "Yes" : "No" },
		{ fields: "Expected Salary Status", status: !dataID?.data?.resume ? "N/A" : dataID?.data?.resume === true ? "Yes" : "No" },
		{ fields: "Total work experience", status: !dataID?.data?.resume ? "N/A" : dataID?.data?.resume === true ? "Yes" : "No" },
		{ fields2: "Make Job Private", status2: !dataID?.data?.makeJobPrivate ? "N/A" : dataID?.data?.makeJobPrivate === true ? "Yes" : "No" }
	]




	useEffect(() => {
		if (isErrorID) {
			swal({
				title: "error",
				text: messageID,
				icon: "error"
			})
			dispatch(reset())
		}
	}, [dispatch, isErrorID, messageID])




	const getlink = (e: any) => {
		e.preventDefault()
		if (!link) {
			setLink(true)
			setTimeout(() => {
				setLink(false)
			}, 30000);
		} else {
			setLink(false)
		}
	}


	return (
		<>
			<Modal fullscreen show={show} onHide={() => setShow(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{"Job"}  {isLoadingID ? '...' : !dataID?.data?.jobCode ? "N/A" : dataID?.data?.jobCode}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div id='ViewJob__Container'>

						<main>
							<div id="Job__sections">
								<div className='details'>
									<p className='details__heading'>Job Details</p>
									<div className='details__content'>

										<div className='details__content__left'>
											<label>
												<p>Job Description</p>
											</label>

											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-7 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.jobDescription ? "N/A" : dataID?.data?.jobDescription}</p>}

											<label>
												<p>Team</p>
											</label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-10 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.team ? "N/A" : dataID?.data?.team}</p>}
											<label>
												<p>Experience Level</p>
											</label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-7 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.experienceLevel ? "N/A" : dataID?.data?.experienceLevel}</p>}
											<label>
												<p>Remote</p>
											</label>
											<p className='subheading'>{!dataID?.data?.workplaceType ? "N/A" : dataID?.data?.workplaceType}</p>
										</div>

										<div className='details__content__right'>
											<label>
												<p>Job Function</p>
											</label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-7 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.jobFunction ? "N/A" : dataID?.data?.jobFunction}</p>}
											<label>
												<p>Employment Type</p>
											</label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-7 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.employmentType ? "N/A" : dataID?.data?.employmentType}</p>}
											<label>
												<p>Location</p>
											</label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-7 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.jobLocation ? "N/A" : dataID?.data?.jobLocation}</p>}

											<label>
												<p>Education</p>
											</label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-7 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.education ? "N/A" : dataID?.data?.education}</p>}
										</div>

									</div>
								</div>

								<div className='details'>
									<p className='details__heading'>Recruitment Setting</p>
									<div className='details__content'>

										<div className='details__content__left'>
											<label><p>Job Profile</p></label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-10 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.jobProfile ? "N/A" : dataID?.data?.jobProfile}</p>}

											<label><p>Hiring Manager</p></label>
											<p className='subheading'>{!dataID?.data?.hiringManager ? "N/A" : dataID?.data?.hiringManager}</p>
											<label><p>Opening Date</p></label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-10 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.openingDate ? "N/A" : moment(dataID?.data?.openingDate).format("MMM Do YY")}</p>}

											<label><p>Evaluation Parameter</p></label>
											<p className='subheading'>Interview</p>
										</div>

										<div className='details__content__right'>
											<label><p>Number of Openings</p></label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-10 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.numberOfOpenings ? "N/A" : dataID?.data?.numberOfOpenings}</p>}
											<label><p>Recruiter Tagged</p></label>
											<p className='subheading'>{!dataID?.data?.recruiterTagged ? "N/A" : dataID?.data?.recruiterTagged}</p>
											<label><p>Expiry Date</p></label>
											{isLoadingID ? <p className="card-text placeholder-glow">
												<span className="placeholder col-10 subheading"></span>
											</p> : <p className='subheading'>{!dataID?.data?.expiryDate ? "N/A" : moment(dataID?.data?.expiryDate).format("MMM Do YY")}</p>}
										</div>
									</div>
								</div>
							</div>

							<div id="description__sections">
								<p className='details__heading'>Job description</p>
								<div style={{ display: "flex", marginLeft: "10px" }} >
									<div className=' description__content details__content__left'>
										<label><p>Qualification</p></label>
										{isLoadingID ? <p className="card-text placeholder-glow">
											<span className="placeholder col-7 subheading">
											</span>
										</p> : <p className='subheading'>{!dataID?.data?.qualifications ? "N/A" : dataID?.data?.qualifications}</p>}
									</div>
									<div className=' description__content details__content__right'>
										<label><p>Job Role</p></label>
										{isLoadingID ?
											<p className="card-text placeholder-glow">
												<span className="placeholder col-7 subheading"> </span>
											</p> : <p className='subheading'>{!dataID?.data?.jobRole ? "N/A" : dataID?.data?.jobRole}</p>}
									</div>
								</div>


								<div style={{ display: "flex", marginLeft: "10px" }} >
									<div className=' description__content details__content__left'>
										<label><p>Must have Skill</p></label>
										{isLoadingID ? <p className="card-text placeholder-glow">
											<span className="placeholder col-7 subheading"></span>
										</p> : <ul className='subheading'>{!dataID?.data?.mustHaveSkills ? "N/A" : dataID?.data?.mustHaveSkills?.map(name => <li key={name}> {name} </li>)}</ul>}
									</div>

									<div className=' description__content details__content__right'>
										<label><p>Good to have Skill</p></label>
										{isLoadingID ? <p className="card-text placeholder-glow">
											<span className="placeholder col-7 subheading"></span>
										</p> : <ul className='subheading'>{!dataID?.data?.goodHaveSkills ? "N/A" : dataID?.data?.goodHaveSkills?.map(name => <li key={name}> {name} </li>)}</ul>}
									</div>
								</div>
							</div>

							<div id="JobApplication__sections">
								<div id="JobApplication__source">
									<p className='details__heading'>Job Application Source</p>
									<div className='JobApplication__source_form'>
										<div className='Source__type'>
											<div className='Source__input'>
												<label><p>SOURCE TYPE</p></label>
												<p className='subheading'>Recruitement</p>
											</div>
										</div>
										<div className='Source__name'>
											<div className='Source__input'>
												<label><p>SOURCE NAME</p></label>
												<p className='subheading'>Outcess Solution</p>
											</div>
										</div>

										<Button
											onClick={getlink}
											variant="contained"
											size='small'
											className='view-HIRED-profile'
											type="submit"
											style={{ height: '2.5rem' }}>Generate Link</Button>
									</div>
									<div className='Source__input__container'>


										<div className='Source__input'>
											<label><p> 					{link === false ? "LINK" : "CLICK ON THE ICON TO COPY LINK"}</p></label>
											<p className='subheading'>
												{link === false ? "See link" : <a href="/">
													<div className='ClipboardButton'>
														<span>{`${hostbaseUrl}/hire/${dataID?.data?.id}`} </span>
														<span><CopyToClipboardButton url={dataID?.data?.id} /></span>
													</div>
												</a>}
											</p>
											<QrCodeGenerator url={`${hostbaseUrl}/hire/${dataID?.data?.id}`} link={link} />
										</div>
									</div>
								</div>
							</div>

							<div id="Candidates__field__container">
								<p className='fieldtitle'>Candidates Field</p>
								<div className='Candidates__field__info'>
									<div className='Candidates__field__title'>
										<p>Profile Info</p>
									</div>
									<div id='profile__info__container'>
										<div className='profile__info__fields'>
											<div className='Profile__fields__systemField'>
												<p>System Fields</p>
												<div className='field' >
													{
														systemFields?.map((field, i) => (
															<div className='fieldlist' key={i}>
																<p className='subheading-right'>{field?.fields}</p>
															</div>
														))
													}
												</div>
											</div>
											<div className='Profile__fields__Required'>
												<p>Required *</p>
												<div className='field' >
													{
														systemFields?.map((field, i) => (
															<div className='fieldlist' key={i}>
																<p className='subheading' id={field.status ? "subheading-green" : "subheading-red"}>{field.status}</p>
															</div>
														))
													}
												</div>
											</div>
										</div>
										<div className='profile__info__fields'>
											<div className='Profile__fields__customField'>
												<p>Custom Fields</p>
												<div className='field' >
													{
														systemFields?.map((field, i) => (
															<div className='fieldlist' key={i}>
																<p className='subheading-right' >{field.fields2}</p>
															</div>
														))
													}
												</div>
											</div>
											<div className='Profile__fields__Required'>
												<p >Required *</p>
												<div className='field' >
													{
														systemFields?.map((field, i) => (
															<div className='fieldlist' key={i}>
																<p className='subheading' id={field.status ? "subheading-green" : "subheading-red"}>{field.status2}</p>
															</div>
														))
													}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div id="Education__details_container">
									<div className='Education__details_title'>
										<p className='title'>Education Details</p>
									</div>
									<div id='Education__info__container'>
										<div className='Education__details__field'>
											<div className='Education__field' >
												<p className='subheading-right'>Education Details </p>
											</div>
											<div className='Required__field'>
												{isLoadingID ? <p className="card-text placeholder-glow">
													<span className="placeholder col-7 subheading"></span>
												</p> : <p className='subheading' id={dataID?.data?.educationDetails ? "subheading-green" : "subheading-red"}>{!dataID?.data?.educationDetails ? "N/A" : dataID?.data?.educationDetails === true ? "Yes" : "No"}</p>}
											</div>
										</div>
										<div></div>
									</div>
								</div>

								<div id="Education__details_container">
									<div className='Education__details_title'>
										<p className='title'>Work Experience</p>
									</div>
									<div id='Education__info__container'>
										<div className='Education__details__field'>
											<div className='Education__field' >
												<p className='subheading-right'>Work Experience</p>
											</div>
											<div className='Required__field'>
												{isLoadingID ? <p className="card-text placeholder-glow">
													<span className="placeholder col-7 subheading"></span>
												</p> : <p className='subheading' id={dataID?.data?.workExperience ? "subheading-green" : "subheading-red"}>{!dataID?.data?.workExperience ? "N/A" : dataID?.data?.workExperience === true ? "Yes" : "No"}</p>}
											</div>
										</div>
										<div></div>
									</div>

								</div>
							</div>
						</main>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default ViewJobModal



